export const useSessionValidation = () => {
  const teamStore = useTeamStore()

  /**
   * Checks if the stored session is from today's date
   * @returns boolean indicating if session is valid for today
   */
  const isStoredSessionValid = (): boolean => {
    // If there's no stored session data, it's invalid
    if (!teamStore.instructorSecret || !teamStore.sessionDate) {
      console.log('Session validation: No stored session or session date')
      return false
    }

    // Check if session date is from today
    const today = new Date().toISOString().split('T')[0] // YYYY-MM-DD format
    const isFromToday = teamStore.sessionDate === today

    console.log(`Session validation: stored date=${teamStore.sessionDate}, today=${today}, isValid=${isFromToday}`)
    
    return isFromToday
  }

  /**
   * Clears all session-related storage and redirects to connection page
   * This should be used when a stored session is determined to be invalid/stale
   */
  const clearStaleSession = async () => {
    console.log('Clearing stale session data...')
    
    try {
      // Clear the team store (this will clear localStorage/sessionStorage via persistence)
      teamStore.clearStore()

      // Clear other stores that might have session data
      const cardGameStore = useCardGameStore()
      const slideshowStore = useSlideshowStore() 
      const timerStore = useTimerStore()
      const observeStore = useObserveStore()

      cardGameStore.clearStore()
      slideshowStore.resetIndex()
      // Use $reset for stores that don't have clearStore method
      timerStore.$reset()
      observeStore.$reset()

      console.log('All stores cleared due to stale session')

      // Navigate to the team connection page
      await navigateTo('/team/bootstrap/enterCode', { replace: true })

    } catch (error) {
      console.error('Error clearing stale session:', error)
      // Even if there's an error, try to navigate to the connection page
      await navigateTo('/team/bootstrap/enterCode', { replace: true })
    }
  }

  /**
   * Validates stored session and either allows reconnection or clears stale data
   * @returns Promise<boolean> indicating if stored session is valid for reconnection
   */
  const validateStoredSession = async (): Promise<boolean> => {
    if (isStoredSessionValid()) {
      console.log('Stored session is valid - allowing reconnection')
      return true
    } else {
      console.log('Stored session is stale - clearing and redirecting')
      await clearStaleSession()
      return false
    }
  }

  return {
    isStoredSessionValid,
    clearStaleSession,
    validateStoredSession
  }
}
